import BaseService from "../../services/BaseService";
import ReportService from "../../services/ReportService";

export default {
    state: () => ({
        net_worth_data: {}
    }),
    getters: {
        netWorthData: state => {
            return state.net_worth_data;
        },
    },
    mutations: {
        SET_NET_WORTH_DATA(state, net_worth_data) {
            state.net_worth_data = net_worth_data;
        },
    },
    actions: {
         netWorth( { commit }, data) {
            if (data) {
                ReportService.netWorth(data).then((result) => {
                    if (result.status === BaseService.STATUS_200) {
                        commit('SET_NET_WORTH_DATA', result.data);
                    }
                });
            }
        },
    },
}